module.exports = __webpack_public_path__ + "static/media/div2N-small.58695b43.jpg";